<div class="modal-content-wrapper">
  <header>
    <div [hidden]="hideEnteredCFGString" class="col-md-12 clear-padding">
      <div class="col-md-3" style="margin-left:auto;margin-right:auto;">
        <label class="darkblue-label" for="txtConfigString">Enter Config String &nbsp;</label>
        <input id="txtConfigString" (blur)="CFGStringEntered()" [(ngModel)]="EnteredCFGString" />      
      </div>
    </div>
    <div class="col-md-12 clear-padding">
      <div class="col-md-6" style="margin-left:auto;margin-right:auto;text-align:center;">
        <span class="darkblue-label" [ngClass]="{'invalid':EnteredCFGString.length > 0 && ConfigString != EnteredCFGString, 'valid': EnteredCFGString.length > 0 && ConfigString == EnteredCFGString}" [hidden]="ConfigString.length == 0">Config String: {{ConfigString}}</span>
      </div>
    </div>
    <div class="col-md-12">
      <nav class="navbar navbar-expand-md navbar-dark">
        <div class="container" style="margin-bottom:0px;">
          <ul class="navbar-nav flex-grow cpqtabs">
            <li class="nav-item" *ngFor="let pageTab of CurrentCPQUI.Pages" id="page_{{pageTab.Index}}" [routerLinkActive]="GetNavCSSClass(pageTab.Index)" [ngClass]="{'clickable':true,'nav-item':true,'active':true,'link-active':true,'current':pageTab.Active}">
              <a class="nav-link clickable" style="position:relative;" (click)="OptionHeader_Click(pageTab.Index)">
                {{StripHTML(pageTab.Caption)}}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </header>
  <section #cpqContainer>
    <div class="col-md-12 mx-auto row" #cpqDiv>
      <div class="col-md-11">
        <div *ngFor="let page of CurrentCPQUI.Pages" id="page_{{page.Index}}_Content" class="projectTabContent" [ngClass]="GetCSSClass(page.Index)">
          <app-cpqpage [CurrentCPQPage]="page" (ChangeEmitter)="OnPageChange($event)" (InvalidEmitter)="CheckForInvalid()"></app-cpqpage>
        </div>
      </div>
    </div>
    <div #spinnerModal id="spinnerModal" [hidden]="hideLoadingModal" style="width:100%;height:inherit;float:left;position:absolute;z-index:10000;display:block;left:0;top:0px;bottom:0px; background-color:#AAAAAA;opacity:0.4;">
      <div style="position: absolute; top: 45%; left: 45%;">
        <mat-spinner mode="indeterminate"></mat-spinner>
      </div>
    </div>
  </section>
  <footer>
    <div class="modal-button-row">
      <button [hidden]="closeHidden" style="margin:10px;" id="btnCloseModal" class="blue cancel" [ngClass]="{'buttonDisabled':CloseButtonDisabled}" [disabled]="CloseButtonDisabled" (click)="closeMethod()" value="Back">Close</button>
      <button [hidden]="acceptHidden" style="margin:10px;" id="btnActionModal" class="blue continue" [ngClass]="{'buttonDisabled':ActionButtonDisabled}" [disabled]="ActionButtonDisabled" (click)="actionMethod()" value="Accept">Accept</button>
    </div>
  </footer>
</div>
